import { ENDPOINT } from '../../network/ENDPOINT';
import { callApiToServer, putApiToServer } from '../callApi';

export async function editExpensesAPI(
        authtoken,   
        payload,
        id
){
    try {
        let header = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            "authorization": "Berear " + authtoken
        };

        let body = JSON.stringify(payload);

        let endUrl = `${ENDPOINT.edit_expenses}/${id}`;

        let responseData = await putApiToServer(body, header, "PUT", endUrl);

        return responseData;

    } catch (err) {
        throw err;
    }
}
